<script setup lang="ts">
import { DronecastPlayer } from '@/sdk'
import { useDronecastStore } from '@/stores/dronecastStore'
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const store = useDronecastStore()
const websocketUrl = computed(() => store.websocketUrl)

const gcs = route.query.gcs as string || ''
const drone = route.query.drone as string || ''
const camera = route.query.camera as string || ''
const yolo = route.query.yolo as string || ''
const hasParams = !!(gcs && drone && camera)

const player = ref<InstanceType<typeof DronecastPlayer> | null>(null)
const yoloEnabled = ref(yolo === 'true' || yolo === '1')

onMounted(() => {
  if (hasParams) {
    setTimeout(() => player.value?.play({ gcs, drone, camera }), 300)
  }
})
</script>

<template>
  <div class="service-fullscreen">
    <div v-if="!hasParams" class="service-error">
      <p>URL 파라미터가 누락되었습니다.</p>
      <p class="hint">?gcs=...&amp;drone=...&amp;camera=... 형식으로 접근하세요.</p>
    </div>
    <template v-else>
      <div class="yolo-toggle">
        <button class="btn-yolo" :class="{ active: yoloEnabled }" @click="yoloEnabled = !yoloEnabled">
          YOLO {{ yoloEnabled ? 'ON' : 'OFF' }}
        </button>
      </div>
      <DronecastPlayer
        ref="player"
        :castroomId="{ gcs, drone, camera }"
        :wsUrl="websocketUrl"
        :detectionEnabled="yoloEnabled"
      />
    </template>
  </div>
</template>

<style scoped>
.service-fullscreen {
  width: 100vw;
  height: 100vh;
  background: #000;
}
.service-error {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #aaa;
  font-size: 14px;
}
.hint { font-size: 12px; color: #666; margin-top: 8px; }
.yolo-toggle {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}
.btn-yolo {
  background: rgba(0,0,0,0.6);
  color: #aaa;
  border: 1px solid #555;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
}
.btn-yolo.active {
  background: #28a745;
  color: #fff;
  border-color: #28a745;
}
</style>
